// stores/auth.js
import { defineStore } from 'pinia'
import { BASE_URL, getBaseUrl } from '@/scripts/base'
import { useCookies } from "vue3-cookies";
import axios from "axios";

const { cookies } = useCookies();

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user_by_MEM: JSON.parse(localStorage.getItem('user_by_MEM') || 'null') || null,
    PERM: JSON.parse(localStorage.getItem('permissions_by_MEM') || 'null') || null,
    ERROR: null,
    auth_error_message: null,
    isInitialized: false, // Добавляем флаг инициализации
  }),

  getters: {
    user: (state) => state.user_by_MEM,
  },

  actions: {

    async initializeAuth() {
        try {
          // Проверяем наличие токена
          if (this.inspectToken()) {
            // Если есть токен, но нет данных пользователя - загружаем их
            if (!this.user_by_MEM) {
              await this.objectUser();
            }
            // Если есть refresh token, но access token истек - обновляем
            if (cookies.get('memorial35_refresh_token') && !cookies.get('memorial35_access_token')) {
              await this.refreshToken();
            }
          }
          this.isInitialized = true;
          return true;
        } catch (error) {
          console.error('Auth initialization error:', error);
          this.isInitialized = true; // Все равно помечаем как инициализированное
          return false;
        }
      },

    setError(error: null) {
      this.ERROR = error;
    },
    
    UPDATE_TOKEN(access: any, expireTime: number) {
      cookies.set('memorial35_access_token', access, expireTime);
    },

    UPDATE_REFRESH_TOKEN(refresh: any, expireTime: number) {
      cookies.set('memorial35_refresh_token', refresh, expireTime);
    },

    UPDATE_USER(data: any) {
      localStorage.setItem('user_by_MEM', JSON.stringify(data));
      this.user_by_MEM = data;
    },
    
    LOGOUT() {
      cookies.remove('memorial35_access_token');
      cookies.remove('memorial35_refresh_token');
      localStorage.removeItem('user_by_MEM');
      localStorage.removeItem('permissions_by_MEM');
      this.user_by_MEM = {};
      this.PERM = null;
    },
    
    UPDATE_AUTH_ERROR(message: null) {
      this.auth_error_message = message;
    },
    
    async obtainToken(data: { username: any; password: any; }) {
      try {
        const params = {
          username: data.username,
          password: data.password,
        };
        
        const response = await axios.post(getBaseUrl() + 'auth/token-admin/', params);
        
        if (response.data.access_token) {
          this.UPDATE_TOKEN(response.data.access_token, 60 * 60 * 24 * 30 * 1000); 
        }
        if (response.data.refresh_token) {
          this.UPDATE_REFRESH_TOKEN(response.data.refresh_token, 60 * 60 * 24 * 30 * 1000);
        }
        
        this.UPDATE_AUTH_ERROR(null);
        this.setError(null);
        return true;
      } catch (error) {
        throw error;
      }
    },
    
    async refreshToken() {
      try {
        const refreshToken = cookies.get('memorial35_refresh_token');
        if (!refreshToken) {
          this.LOGOUT();
          return false;
        }
    
        const params = {
          refresh_token: refreshToken
        };
        
        const response = await axios.post(getBaseUrl() + 'auth/token/refresh/', params);
        
        if (response.data.access_token) {
          this.UPDATE_TOKEN(response.data.access_token, 60 * 60 * 24 * 30 * 1000);
        }
        if (response.data.refresh_token) {
          this.UPDATE_REFRESH_TOKEN(response.data.refresh_token, 60 * 60 * 24 * 30 * 1000);
        }
        
        this.UPDATE_AUTH_ERROR(null);
        return true;
      } catch (error) {
        this.LOGOUT(); // При ошибке - разлогиниваем
        throw error;
      }
    },

    logoutUser() {
      this.LOGOUT();
      return true;
    },
    
    inspectToken() {
      return !!cookies.get('memorial35_access_token');
    },
    
    async objectUser() {
      try {
        const response = await BASE_URL.get('/auth/user/');
        this.UPDATE_USER(response.data?.user || {});
        return true;
      } catch (error) {
        throw error;
      }
    },

    setAuthError(message: any) {
      this.UPDATE_AUTH_ERROR(message);
    }
  },
  persist: true, // Добавьте эту строку для сохранения состояния
});